<template>
  <v-card class="mb-4 mt-1 no-border">
    <v-layout>
      <v-flex xs12 class="pt-0">
        <v-progress-linear
          v-if="!markets[exchange]"
          :indeterminate="true"
          height="3"
          color="primary"
        ></v-progress-linear>
        <v-tabs
          v-if="markets[exchange]"
          class="my-0"
          :slider-color="sliderColor"
          centered
          :value="value"
        >
          <v-tab
            v-for="(baseMarkets, base) in markets[exchange]"
            :key="base"
            ripple
            >{{ base }}</v-tab
          >
          <v-tabs-items touchless>
            <v-tab-item
              v-for="(baseMarkets, base) in markets[exchange]"
              :key="base"
            >
              <slot
                v-bind:markets="baseMarkets"
                v-bind:base="base"
                v-bind:exchange="exchange"
              ></slot>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "base-market-tabs-dashboard",
  props: ["value", "exchange"],
  watch: {
    value(val) {
      this.$emit("input", val)
    }
  },
  computed: {
    ...mapGetters({
      markets: "accountValue/tabsNamesForProfits",
      themeDark: "settings/darkmode"
    }),
    sliderColor() {
      return this.themeDark ? "#ffffff" : "#103A84";
    }
  }
};
</script>

<style scoped>
.no-border {
  box-shadow: none !important;
  background-color: inherit !important;
  border-color: inherit !important;
}
>>> .theme--light .v-tabs__wrapper {
  padding-top: 0px;
}
>>> .theme--light.v-tabs__bar {
  background-color: #e6efff !important;
}
>>> .theme--light .v-tabs__item {
  color: #7395d0;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .theme--light .v-tabs__item--active {
  color: #103a84 !important;
}
/* dark mode */
>>> .theme--dark.v-tabs__bar {
  background-color: #454547 !important;
}
>>> .theme--dark .v-tabs__item {
  color: #959596;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .theme--dark .v-tabs__item--active {
  color: #ffffff !important;
}
>>> .theme--dark .v-tabs__wrapper {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/global/BaseMarketTabsDashboard.vue